import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6 11.9961H18",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12 18L6 12L12 6",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "w-full h-full flex"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "animate-spin h-10 w-10 text-white",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col py-6 px-4 justify-center space-y-10"
}
const _hoisted_6 = { class: "flex flex-col space-y-2" }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar, onIonViewDidEnter,
  useIonRouter,
} from '@ionic/vue';
import {inject, onMounted, reactive, Ref, ref, watch, watchEffect} from 'vue';
import ApiService from "@/services/api/apiService";
import {DateTime} from "luxon";
import MenuButton from "@/components/MenuButton.vue";
import {Preferences} from "@capacitor/preferences";
import {PreferenceKey} from "@/definitions/PreferenceKey";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {UserInterface} from "@/interfaces/UserInterface";
import InputCheckbox from "@/components/InputCheckbox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSettingsAccountPrivacy',
  setup(__props) {

const user: Ref<UserInterface | undefined> = inject('user') as Ref<UserInterface | undefined>

const loading = ref(true)
const ionRouter = useIonRouter()
const busy = ref(false)

const preferences: any = reactive({
  publicProfileEnabled: [true],
  profileLastOnline: [true],
  profileViewReceipts: [true],
  allowFriendRequests: [true],
  onlyFriendsCanDirectMessage: [true],
  onlyFriendsCanAddYouToGroupChats: [true],
})

onIonViewDidEnter(async () => {

  const userPreferences = (await ApiService.User().get()).preferences
  preferences.publicProfileEnabled = [Boolean(Number(userPreferences[PreferenceKey.PublicProfileEnabled]))]
  preferences.profileViewReceipts = [Boolean(Number(userPreferences[PreferenceKey.ProfileViewReceipts]))]
  preferences.profileLastOnline = [Boolean(Number(userPreferences[PreferenceKey.ProfileShowLastOnline]))]
  preferences.allowFriendRequests = [Boolean(Number(userPreferences[PreferenceKey.AllowFriendRequests]))]
  preferences.onlyFriendsCanDirectMessage = [Boolean(Number(userPreferences[PreferenceKey.OnlyFriendsCanDirectMessage]))]
  preferences.onlyFriendsCanAddYouToGroupChats = [Boolean(Number(userPreferences[PreferenceKey.OnlyFriendsCanAddYouToGroupChats]))]

})


const goBack = async () => {
  await ionRouter.back()
}

watch(() => ({...preferences}), async (preference, previousPreference) => {

  if (loading.value) return loading.value = false

  if (previousPreference.publicProfileEnabled[0] !== preference.publicProfileEnabled[0]) {
    await ApiService.User().setPreference(PreferenceKey.PublicProfileEnabled, preference.publicProfileEnabled[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

  if (previousPreference.allowFriendRequests[0] !== preference.allowFriendRequests[0]) {
    await ApiService.User().setPreference(PreferenceKey.AllowFriendRequests, preference.allowFriendRequests[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

  if (previousPreference.onlyFriendsCanDirectMessage[0] !== preference.onlyFriendsCanDirectMessage[0]) {
    await ApiService.User().setPreference(PreferenceKey.OnlyFriendsCanDirectMessage, preference.onlyFriendsCanDirectMessage[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

  if (previousPreference.onlyFriendsCanAddYouToGroupChats[0] !== preference.onlyFriendsCanAddYouToGroupChats[0]) {
    await ApiService.User().setPreference(PreferenceKey.OnlyFriendsCanAddYouToGroupChats, preference.onlyFriendsCanAddYouToGroupChats[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

  if (previousPreference.profileViewReceipts[0] !== preference.profileViewReceipts[0]) {
    await ApiService.User().setPreference(PreferenceKey.ProfileViewReceipts, preference.profileViewReceipts[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

  if (previousPreference.profileLastOnline[0] !== preference.profileLastOnline[0]) {
    await ApiService.User().setPreference(PreferenceKey.ProfileShowLastOnline, preference.profileLastOnline[0])
    Observable.emit(ObservableEvent.UserChanged)
  }

}, {deep: true})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), {
                slot: "start",
                class: "mr-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { class: "text-white font-medium text-2xl" }, {
                default: _withCtx(() => [
                  _createTextVNode("Privacy")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { class: "flex h-full w-full" }, {
        default: _withCtx(() => [
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.publicProfileEnabled,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((preferences.publicProfileEnabled) = $event)),
                    option: {
              text: 'Public Web Profile',
              value: true
            }
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.allowFriendRequests,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((preferences.allowFriendRequests) = $event)),
                    option: {
              text: 'Allow friend requests',
              value: true
            }
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.onlyFriendsCanDirectMessage,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((preferences.onlyFriendsCanDirectMessage) = $event)),
                    option: {
              text: 'Only friends can direct message',
              value: true
            }
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.onlyFriendsCanAddYouToGroupChats,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((preferences.onlyFriendsCanAddYouToGroupChats) = $event)),
                    option: {
              text: 'Only friends can add you to group chats',
              value: true
            }
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.profileViewReceipts,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((preferences.profileViewReceipts) = $event)),
                    option: {
              text: 'Profile view receipts',
              value: true
            }
                  }, null, 8, ["modelValue"]),
                  _createVNode(InputCheckbox, {
                    name: "display",
                    "input-type": "toggle",
                    modelValue: preferences.profileLastOnline,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((preferences.profileLastOnline) = $event)),
                    option: {
              text: 'Last online status',
              value: true
            }
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})